import { render } from "./NcrmDataProtectionWorkspace.vue?vue&type=template&id=763a193b&scoped=true"
import script from "./NcrmDataProtectionWorkspace.vue?vue&type=script&lang=js"
export * from "./NcrmDataProtectionWorkspace.vue?vue&type=script&lang=js"

import "./NcrmDataProtectionWorkspace.vue?vue&type=style&index=0&id=763a193b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763a193b"]])

export default __exports__